import { useState } from 'react'
import useAsyncEffect from 'shared/hooks/use-async-effect'
import styled from 'styled-components'
import CreationToolFont from '../../../../types/font'
import { preloadFont } from '../../../../utils/preload'
import SelectListComponent from '../../../select-list'
import { SourceEditorCaptionStyle } from '../../types'

const BASE_FONT_SIZE = 18

const SelectList = styled(SelectListComponent)`
    width: 100%;
`

type Props = {
    captionStyle: SourceEditorCaptionStyle
    setCaptionStyle: (style: SourceEditorCaptionStyle) => void
    customFontUrl?: string
}

const CreationSourceEditorCaptionFontDropdown = ({ captionStyle, setCaptionStyle, customFontUrl }: Props) => {
    const [fonts, setFonts] = useState<CreationToolFont[]>(CreationToolFont.all())
    const { font: currentFont } = captionStyle

    useAsyncEffect(async () => {
        if (!customFontUrl) return

        try {
            // if custom font provided, load font with font family name
            await preloadFont(customFontUrl, CreationToolFont.fontFamily(CreationToolFont.Custom))
            setFonts([...CreationToolFont.all(), CreationToolFont.Custom])
        } catch (e) {
            console.log(e)
        }
    }, [customFontUrl, setFonts])

    const onChange = (font: CreationToolFont) => {
        setCaptionStyle({
            ...captionStyle,
            font,
        })
    }

    return (
        <SelectList
            {...{
                onChange,
                value: currentFont,
                options: fonts.map((font) => ({
                    value: font,
                    label: (
                        <span
                            key={font}
                            style={{
                                fontFamily: CreationToolFont.fontFamily(font),
                                fontSize: `${Math.round(BASE_FONT_SIZE * CreationToolFont.scale(font))}px`,
                                fontWeight: CreationToolFont.fontWeight(font),
                                textTransform: CreationToolFont.isAllCaps(font) ? 'uppercase' : 'none',
                            }}
                        >
                            {CreationToolFont.title(font)}
                        </span>
                    ),
                })),
            }}
        />
    )
}

export default CreationSourceEditorCaptionFontDropdown
